export default __webpack_public_path__ + "static/media/license-bottom-vector-2.4106b70a.png";